module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Scroll', {
    attrs: {
      "on-reach-bottom": _vm.handleReachBottom,
      "height": "680",
      "distance-to-edge": [0, 10]
    }
  }, [_c('div', {
    staticClass: "kucun"
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "daohang"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "color": "#2d8cf0",
      "font-family": "'微软雅黑'"
    },
    on: {
      "click": _vm.tiaozhuan
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-home"
    }
  }), _vm._v(_vm._s(_vm.language.shouye))], 1), _vm._v(">\n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "font-family": "'微软雅黑'"
    }
  }, [_vm._v(_vm._s(_vm.language.zhibaoshuchaxun))])]), _vm._v(" "), _c('div', {
    staticClass: "iptc"
  }, [_c('div', {
    staticClass: "iptlis"
  }, [_c('Icon', {
    staticClass: "ico",
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "iptli",
    attrs: {
      "placeholder": _vm.language.chaxunqingdianjiwo,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal1 = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "numEve"
  }, [_c('div', {
    staticClass: "numlitter"
  }, [_vm._v(_vm._s(_vm.language.gong) + _vm._s(_vm.numnum) + _vm._s(_vm.language.tiao))])])], 1)])]), _vm._v(" "), _c('modal', {
    staticClass: "serchlist",
    attrs: {
      "width": "86%",
      "styles": {
        top: '60px',
        left: '100px'
      }
    },
    model: {
      value: (_vm.modal1),
      callback: function($$v) {
        _vm.modal1 = $$v
      },
      expression: "modal1"
    }
  }, [_c('div', {
    staticClass: "pz"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpinzhong),
      callback: function($$v) {
        _vm.numpinzhong = $$v
      },
      expression: "numpinzhong"
    }
  }, _vm._l((_vm.selectDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "pinzhongs"
  }, [_vm._v(_vm._s(_vm.language.pinzhong))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ph"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.numpaihao),
      callback: function($$v) {
        _vm.numpaihao = $$v
      },
      expression: "numpaihao"
    }
  }, _vm._l((_vm.shopDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _c('span', {
    staticClass: "paihaos"
  }, [_vm._v(_vm._s(_vm.language.paihao))])], 1), _vm._v(" "), _c('div', {
    staticClass: "hou"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numhou),
      callback: function($$v) {
        _vm.numhou = $$v
      },
      expression: "numhou"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hous"
  }, [_vm._v(_vm._s(_vm.language.hou))])], 1), _vm._v(" "), _c('div', {
    staticClass: "kuan"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numkuan),
      callback: function($$v) {
        _vm.numkuan = $$v
      },
      expression: "numkuan"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "kuans"
  }, [_vm._v(_vm._s(_vm.language.kuan))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chang"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numchang),
      callback: function($$v) {
        _vm.numchang = $$v
      },
      expression: "numchang"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "changs"
  }, [_vm._v(_vm._s(_vm.language.chang))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ck"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numcangku),
      callback: function($$v) {
        _vm.numcangku = $$v
      },
      expression: "numcangku"
    }
  }, _vm._l((_vm.wareDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "cangkus"
  }, [_vm._v(_vm._s(_vm.language.cangku))])], 1), _vm._v(" "), _c('div', {
    staticClass: "kunb"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numkunbaohao),
      callback: function($$v) {
        _vm.numkunbaohao = $$v
      },
      expression: "numkunbaohao"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "kunbaohaos"
  }, [_vm._v(_vm._s(_vm.language.kunbaohao))])], 1), _vm._v(" "), _c('div', {
    staticClass: "muj"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.nummujuanhao),
      callback: function($$v) {
        _vm.nummujuanhao = $$v
      },
      expression: "nummujuanhao"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mujuanhaos"
  }, [_vm._v(_vm._s(_vm.language.mujuanhao))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chxz"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "name": "",
      "id": "",
      "clearable": ""
    },
    model: {
      value: (_vm.cunhuo),
      callback: function($$v) {
        _vm.cunhuo = $$v
      },
      expression: "cunhuo"
    }
  }, _vm._l((_vm.cityList2), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })), _vm._v(" "), _c('span', {
    staticClass: "cunhuo"
  }, [_vm._v(_vm._s(_vm.language.yewuleixing))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chanpinyuanliao"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.language.qingxuanze,
      "name": "",
      "id": "",
      "clearable": ""
    },
    model: {
      value: (_vm.cpyl),
      callback: function($$v) {
        _vm.cpyl = $$v
      },
      expression: "cpyl"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })), _vm._v(" "), _c('span', {
    staticClass: "cunhuo"
  }, [_vm._v(_vm._s(_vm.language.cunhuoxingzhi))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(249,249,249)"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "chaxun",
    on: {
      "click": function($event) {
        _vm.chaxun()
      }
    }
  }, [_vm._v(_vm._s(_vm.language.chaxun))]), _vm._v(" "), _c('div', {
    staticClass: "chongzhi",
    on: {
      "click": function($event) {
        _vm.chongzhis()
      }
    }
  }, [_vm._v(_vm._s(_vm.language.chongzhi))])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "nimei",
      "id": "formForViewCertificate",
      "method": "post",
      "target": "_blank"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "userNum",
      "value": "900001"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "uCode",
      "value": "U07266"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "companyNo",
      "value": "3N044"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "userNo",
      "value": "U07266_060"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "system",
      "value": "NS"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderNum",
      "value": "LD3BJ48016"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "printFlag",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "downFlag",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "saleNetwork",
      "value": "A"
    }
  })])]), _vm._v(" "), _vm._l((_vm.restab), function(x) {
    return _c('table', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tabshow),
        expression: "tabshow"
      }],
      key: x,
      staticClass: "gridtable"
    }, [_c('tr', {
      staticClass: "returnButton",
      on: {
        "click": _vm.returnButton
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "right",
        "cursor": "pointer"
      },
      attrs: {
        "colspan": "12"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "3px"
      }
    }, [_vm._v(_vm._s(_vm.language.guanbi))]), _c('Icon', {
      attrs: {
        "type": "close-circled"
      }
    })], 1)]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.language.zhengshuhao))]), _c('td', [_vm._v(_vm._s(x.tcNumTc))]), _c('th', [_vm._v(_vm._s(_vm.language.chenpinpinming))]), _c('td', [_vm._v(_vm._s(x.prodName))]), _c('th', [_vm._v(_vm._s(_vm.language.hetonghao))]), _c('td', [_vm._v(_vm._s(x.orderNum))]), _c('th', [_vm._v(_vm._s(_vm.language.jiaohuoriqi))]), _c('td', [_vm._v(_vm._s(x.deliveryDateChr))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.language.gangjuanhao))]), _c('td', [_vm._v(_vm._s(x.coilNumTc))]), _c('th', [_vm._v(_vm._s(_vm.language.kunbaohao))]), _c('td', [_vm._v(_vm._s(x.packNum))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.language.luhao))]), _c('td', [_vm._v(_vm._s(x.heatNumTc))]), _c('th', [_vm._v(_vm._s(_vm.language.hou))]), _c('td', [_vm._v(_vm._s(x.thickTc))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.language.kuan))]), _c('td', [_vm._v(_vm._s(x.widthTc))]), _c('th', [_vm._v(_vm._s(_vm.language.chang))]), _c('td', [_vm._v(_vm._s(x.lengthTc))]), _c('th', [_vm._v(_vm._s(_vm.language.zhangshu))]), _c('td', [_vm._v(_vm._s(x.n_pack))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.language.zhongliang))]), _c('td', [_vm._v("T" + _vm._s(x.massTc))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.language.qufu))]), _c('td', [_vm._v(_vm._s(x.yieldStrengthTq))]), _c('th', [_vm._v(_vm._s(_vm.language.kangla))]), _c('td', [_vm._v(_vm._s(x.tensionStreTq))]), _c('th', [_vm._v(_vm._s(_vm.language.shenchang))]), _c('td', {
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v(_vm._s(x.elongationTq))])])])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "name": "addmeauOne",
      "on-click": _vm.showNameTabs(_vm.nameTab),
      "border": ""
    }
  }, [_c('i-table', {
    attrs: {
      "border": "",
      "columns": _vm.columns1,
      "data": _vm.loadnum
    }
  })], 1), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jiazai),
      expression: "jiazai"
    }],
    staticClass: "demo-spin-col",
    attrs: {
      "span": "24"
    }
  }, [_c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "demo-spin-icon-load",
    attrs: {
      "type": "load-c",
      "size": "18"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Loading")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMoreData),
      expression: "addMoreData"
    }],
    staticClass: "add_more_data"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.moredata),
      expression: "!moredata"
    }],
    staticClass: "add_more_data_btn"
  }, [_vm._v("\n              " + _vm._s(_vm.language.jiazaiwanbi) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "bootBanner"
  }, [_c('p', {
    staticClass: "liang"
  }, [_c('span', {
    staticClass: "add_more_all_weight"
  }, [_vm._v(_vm._s(_vm.language.heji) + "： "), _c('div', {
    staticClass: "add_more_all_weight_span"
  }, [_vm._v(_vm._s(_vm.resl))]), _vm._v("kg")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92db6764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/warranty.vue
// module id = 934
// module chunks = 1